import { makeStyles } from '@material-ui/core/styles';
import Typography, { TypographyProps } from '@material-ui/core/Typography';
import React from 'react';

const useStyles = makeStyles(theme => ({
  label: {
    marginRight: theme.spacing(0.5),
  },
}));

export interface LabelProps extends TypographyProps {
  label: string;
}

/**
 * @deprecated
 * @example
 *
 * This is just a weak wrapper on Typography. Use `<Typography />` instead with secondary text color, noWrap, and overline settings:
 * ```
 * <Typography color="textSecondary" noWrap variant="overline">
 *  {label}
 * </Typography>
 */
export const TableHeaderCellLabel: React.FC<LabelProps> = ({ label, ...props }) => {
  const classes = useStyles();

  return (
    <Typography className={classes.label} color="textSecondary" noWrap variant="overline" {...props}>
      {label}
    </Typography>
  );
};

export default TableHeaderCellLabel;
